import { render, staticRenderFns } from "./GDPR.vue?vue&type=template&id=e9935f46&scoped=true&"
import script from "./GDPR.vue?vue&type=script&lang=js&"
export * from "./GDPR.vue?vue&type=script&lang=js&"
import style0 from "./GDPR.vue?vue&type=style&index=0&id=e9935f46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9935f46",
  null
  
)

export default component.exports